import React, { useState } from "react"
import { Icon } from "semantic-ui-react"
import AddDeviceToGroupPage from "../../../../../Pages/MainPanel/MainPanelBody/Groups/GroupModal/EditGroupModal/GroupView/AddDeviceToGroupPage"
import BifrostButton from "../../../../BifrostElementComponent/BifrostButton/BifrostButton"
import BifrostModal from "../../../BifrostModal/BifrostModal"

const AddDeviceToGroupModal = ({ group, refreshData }) => {
	const [openModal, setOpenModal] = useState(false)

	return (
		<BifrostModal
			title={"Add device to Group"}
			open={openModal}
			setOpen={setOpenModal}
			trigger={
				<BifrostButton>
					<Icon name="add" size="small" />
					Add Device
				</BifrostButton>
			}
			modalPage={
				<AddDeviceToGroupPage
					group={group}
					onFinish={() => {
						refreshData()
					}}
				/>
			}
		/>
	)
}

AddDeviceToGroupModal.propTypes = {}

export default AddDeviceToGroupModal
